<template>
  <div class="reason-select-box">
    <div class="sub-title">{{ title }}</div>
    <van-radio-group v-model="radio">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="reason-select-item"
        @click="select(item, index)"
      >
        <div>
          {{ item.value }}
        </div>
        <van-radio :name="item.key" />
      </div>
    </van-radio-group>

    <van-form
      ref="form"
      scroll-to-error
      validate-first
      :show-error-message="false"
      v-if="showOtherInput"
    >
      <van-field
        name="rescueOpinion"
        class="textarea-box"
        v-model.trim="rescueOpinion"
        rows="3"
        autosize
        type="textarea"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="inputHandle"
        :rules="[{ required: true, message: placeholder, trigger: 'onBlur'}]"
      />
    </van-form>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    dataList: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: () => {}
    },
    placeholder: {
      type: String,
      default: '请输入原因'
    },
    maxlength: {
      type: [Number, String],
      default: '500'
    }
  },
  data() {
    return {
      current: undefined,
      rescueOpinion: '',
      radio: '',
      currentIndex: -1
    };
  },
  computed: {
    showOtherInput() {
      return this.currentIndex === this.dataList.length - 1 || this.radio === 'OSS_CANCEL_REASON_05';
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.radio = this.value.code;
    },
    select(item, index) {
      this.currentIndex = index;
      this.radio = item.key;
      const obj = {
        code: item.key,
        desc: item.value
      };
      this.$emit('update:value', obj);
    },
    inputHandle(val) {
      const current = this.dataList[this.currentIndex];
      const obj = {
        code: current.key,
        desc: current.value,
        remark: val
      };
      this.$emit('update:value', obj);
    },
    async validate() {
      if (this.showOtherInput) {
        if (!this.rescueOpinion) {
          this.$toast('请输入取消原因');
        }
        if (this.$refs.form) {
          try {
            await this.$refs.form.validate();
            return true;
          } catch (err) {
            console.log(err);
            this.$toast(err[0].message);
            return false;
          }
        }
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.reason-select-box{
  .sub-title{
    letter-spacing: -0.38px;

    color: #999999;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
  }
  .textarea-box{
    margin-top: 16px;
  }
  .reason-select-item {
    display: flex;
    justify-content: space-between;

    padding: 16px 0;

    letter-spacing: -0.38px;

    color: #383838;
    border-bottom: 1px solid rgba(230,230,230,1);

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    &:last-child {
      margin-bottom: -16px;

      border: none;
    }

    ::v-deep .van-radio{
      .van-radio__icon{
        font-size: 18px;
        &.van-radio__icon--checked .van-icon{
          border-color: #3399FF;
          background-color: #3399FF;
        }
        .van-icon{
          border: 1px solid rgba(153,153,153,1);
        }
      }
    }
  }
}
</style>
